import { render } from "./SurveyDesign.vue?vue&type=template&id=4007599a"
import script from "./SurveyDesign.vue?vue&type=script&lang=js"
export * from "./SurveyDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__